jQuery($ => {

    if ($('.m-note-taking-tool')[0]) {

        function clearNote(element) {
            var note = element;

            note.parents('.m-note-taking-tool').removeClass('m-note-taking-tool--open');

            note.parents('.m-note-taking-tool').find('.m-field__textarea').val('');
        };

        $('.a-note-trigger').click(function () {
            var form = $(this).parent();

            form.addClass('m-note-taking-tool--new-note');
            form.find('.a-textarea').focus();
        });

        $('.js-cancel-note').click(function () {
            var parent = $(this).parents('.m-note-taking-tool');

            clearNote($(this));

            if (parent.hasClass('m-note-taking-tool--edit-note')) {
                parent.removeClass('m-note-taking-tool--edit-note');
            } else if (parent.hasClass('m-note-taking-tool--new-note')) {
                parent.removeClass('m-note-taking-tool--new-note');
            }
        });

        $('.js-delete-note').click(function () {
            var parent = $(this).parents('.m-note-taking-tool'),
                currentNote = parent.find('.m-note-taking-tool__current-note'),
                value = parent.find('.a-textarea').val(),
                post_id = parent.data('post-id'),
                unique_id = parent.data('unique-id');

            if (currentNote.text()) {
                currentNote.text('');
            }

            parent.removeClass('m-note-taking-tool--edit-note');
            parent.removeClass('m-note-taking-tool--has-active-note');

            if (parent.hasClass('m-note-taking-tool--new-note')) {
                parent.removeClass('m-note-taking-tool--new-note');
            }

            if (parent.hasClass('m-note-taking-tool--saved-note')) {
                parent.removeClass('m-note-taking-tool--saved-note');
            }

            clearNote($(this));

            $.post(AJAX.url, {
                action: 'delete_note',
                post_id: post_id,
                unique_id: unique_id,
                value: value,
            }, function (result) {
                if (result.success) {
                    if (parent.addClass('m-note-taking-tool--saved-note')) {
                        parent.removeClass('m-note-taking-tool--saved-note');
                    }
                }
            });
        });

        $('.js-edit-note').click(function () {
            var tool = $(this).parents('.m-note-taking-tool'),
                form = tool.find('.m-note-taking-tool__form'),
                currentNote = tool.find('.m-note-taking-tool__current-note');

            tool.addClass('m-note-taking-tool--edit-note');
            form.find('.m-field__textarea').val(currentNote.text());
            form.find('.m-field__textarea').focus();
        })

        $('.m-note-taking-tool__form').on('submit', function (e) {
            e.preventDefault();

            var value = $(this).find('.m-field .a-textarea').val(),
                parent = $(this).parent(),
                post_id = parent.data('post-id'),
                unique_id = parent.data('unique-id'),
                currentNote = $(this).find('.m-note-taking-tool__current-note');

            $.post(AJAX.url, {
                action: 'save_note',
                post_id: post_id,
                unique_id: unique_id,
                value: value,
            }, function (result) {
                if (result.success) {
                    parent.addClass('m-note-taking-tool--saved-note');
                    currentNote.html(result.data);

                    if (parent.hasClass('m-note-taking-tool--edit-note')) {
                        parent.removeClass('m-note-taking-tool--edit-note');
                    }
                }
            });
        });
    }
});